import Create from "./Create";
import Edit from "./Edit";

export default {
  Edit,
  Create,
};
